import React, { useContext, useEffect, useRef } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { Environment } from 'src/Environment';

import { paymentsDashboardRoute, businessCashAdvanceRoute } from 'src/routing/routes';
import { downloadContractPdf, viewContractPdf } from 'src/helpers/contract';

import HeaderNav from '../../header-nav/header-nav';
import { Card } from 'src/components';

import TealiumEvents from 'src/helpers/tealium-events';
import { OfferContext } from 'src/context/offer-context';
import { MerchantProfileContext } from 'src/context/merchant-profile-context';

import { formatCurrencyAmountSimple } from 'src/helpers/formatting';
import InfoTray from 'src/components/info-tray/info-tray';
import './business-cash-advance-digital-terms.scss';

const CashAdvanceContract = ({ merchantDetails }) => (
  <Card cardTitle="YOUR Business Cash Advance contract" className="application-summary">
    <table className="table application-summary-table is-fullwidth">
      <tbody>
        <tr>
          <td>Merchant name</td>
          <td className="has-text-right">{merchantDetails.merchantName}</td>
        </tr>
        <tr>
          <td>Advance start</td>
          <td className="has-text-right">{merchantDetails.advanceStart}</td>
        </tr>
        <tr>
          <td>Merchant address</td>
          <td className="has-text-right">{merchantDetails.address}</td>
        </tr>
        <tr>
          <td>VAT Number</td>
          <td className="has-text-right">{merchantDetails.vatNumber}</td>
        </tr>
        <tr>
          <td className="has-padding-bottom-4">Advance Amount</td>
          <td className="has-text-right has-padding-bottom-4">
            R {formatCurrencyAmountSimple(merchantDetails.advanceAmount)}
          </td>
        </tr>
        <tr>
          <td>Total repayment</td>
          <td className="has-text-right">
            R {formatCurrencyAmountSimple(merchantDetails.totalRepayment)}
          </td>
        </tr>
      </tbody>
    </table>
  </Card>
);

const PrintButton = ({ merchantDetails, merchant, selectedOffer }) => (
  <button
    onClick={() => {
      viewContractPdf(merchantDetails, merchant, selectedOffer);
      TealiumEvents.viewTCsBCAClickPrint();
    }}
    className="print-button"
  >
    Print
  </button>
);

const DownloadButton = ({ merchantDetails, merchant, selectedOffer }) => (
  <button
    onClick={() => {
      downloadContractPdf(merchantDetails, merchant, selectedOffer);
      TealiumEvents.viewTCsBCAClickDownload();
    }}
    className="download-button"
  >
    Download
  </button>
);

export default function BusinessCashAdvanceDigitalTerms() {
  const { merchant, merchantDetails } = useContext(MerchantProfileContext);
  const { selectedOffer } = useContext(OfferContext);
  const history = useHistory();
  const topOfPage = useRef('top');

  useEffect(() => {
    TealiumEvents.viewTCsBCAPageLoad();
    if (topOfPage.current) {
      topOfPage.current.scrollIntoView(false);
    }
  }, []);

  // TODO: BCA Flag to be removed
  if (Environment.current?.disabledFeatures.bca) {
    return <Redirect push to={paymentsDashboardRoute} />;
  }

  return (
    <div className="BusinessCashAdvanceDigitalTerms">
      <div className="is-hidden-mobile">
        <HeaderNav
          title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
          screenName="Get Financed"
        >
          <div className="columns">
            <div className="column">
              <h1
                className="page-title has-text-left has-margin-bottom-4 is-clickable"
                ref={topOfPage}
                onClick={() => {
                  history.push(businessCashAdvanceRoute);
                }}
              >
                <span className="icon-menu-chevron-left is-icon-5 has-margin-right-6" />
                Business Cash Advance
              </h1>
            </div>
            <div className="column is-narrow has-text-right">
              <div className="is-pulled-right">
                <DownloadButton
                  merchantDetails={merchantDetails}
                  merchant={merchant}
                  selectedOffer={selectedOffer}
                />
              </div>
              <div className="is-pulled-right has-margin-right-6">
                <PrintButton
                  merchantDetails={merchantDetails}
                  merchant={merchant}
                  selectedOffer={selectedOffer}
                />
              </div>
            </div>
          </div>
          <CashAdvanceContract merchantDetails={merchantDetails} />
        </HeaderNav>
      </div>
      <div className="is-hidden-tablet">
        <InfoTray
          selected={true}
          setSelected={() => history.goBack()}
          title={'Business Cash Advance'}
          isFullscreen={true}
        >
          <p className="top-mobile-page-title navbar-title-mobile is-hidden-tablet">Get Financed</p>
          <CashAdvanceContract merchantDetails={merchantDetails} />
          <div className="buttons-container columns is-mobile">
            <div className="column is-one-third">
              <PrintButton
                merchantDetails={merchantDetails}
                merchant={merchant}
                selectedOffer={selectedOffer}
              />
            </div>
            <div className="column is-two-thirds">
              <DownloadButton
                merchantDetails={merchantDetails}
                merchant={merchant}
                selectedOffer={selectedOffer}
              />
            </div>
          </div>
        </InfoTray>
      </div>
    </div>
  );
}
